import { Assets } from 'pixi.js';

export const PixiAssets = Assets;

const loadedResourceKeys = [];

function allResourceDynamicLoader(pixiAssets, resolve, reject) {
  pixiAssets
    .load(loadedResourceKeys)
    .then((res) => {
      resolve(res);
    })
    .catch(() => {
      reject();
    });
}

export const loadResources = (resources) => {
  return new Promise((resolve, reject) => {
    try {
      resources.forEach((item) => {
        PixiAssets.add(item.name, item.path, item.config);
        loadedResourceKeys.push(item.name);
      });
      allResourceDynamicLoader(PixiAssets, resolve, reject);
    } catch (error) {
      reject(error);
    }
  });
};
